import ErrorCorrectLevelImport from "qr.js/lib/ErrorCorrectLevel";
import QRCodeImport from "qr.js/lib/QRCode";

// qr.js is CommonJS; depending on the bundler the default import is either the
// export itself or a `{ default }` wrapper (same workaround as mfa-setup-dialog).
const QRCodeImpl =
  (QRCodeImport as unknown as { default?: typeof QRCodeImport }).default ??
  QRCodeImport;
const ErrorCorrectLevel =
  (
    ErrorCorrectLevelImport as unknown as {
      default?: typeof ErrorCorrectLevelImport;
    }
  ).default ?? ErrorCorrectLevelImport;

export type QrLevel = "L" | "M" | "Q" | "H";

/**
 * qr.js encodes in 8-bit mode one char code per byte, so anything outside
 * Latin-1 (an emoji, Hebrew in a query string) would be truncated. Hand it the
 * UTF-8 bytes as a byte string instead.
 */
const toUtf8ByteString = (value: string) => {
  const bytes = new TextEncoder().encode(value);
  let out = "";
  for (let i = 0; i < bytes.length; i++) out += String.fromCharCode(bytes[i]);
  return out;
};

/**
 * The module matrix for `value` (true = dark), or null when the value is empty
 * or too long for the largest QR version at this error-correction level.
 */
export const buildQrMatrix = (
  value: string,
  level: QrLevel,
): boolean[][] | null => {
  if (!value) return null;
  try {
    const qr = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
    qr.addData(toUtf8ByteString(value));
    qr.make();
    return qr.modules;
  } catch {
    return null;
  }
};
